<template>
  <div id="app">
    <Nav></Nav>

    <span 
    class="suggest-btn" 
    @click="isShowSuggest = !isShowSuggest"
    >
    →&nbsp;意见反馈
    </span>

    <!-- 路由导航 -->
    <div class="router-nav">
      <ul class="clearfix">
        <router-link
          v-for="(item,index) in routerNavData"
          :key="index"
          :class="{active: item.link == $route.params.name}"
          @click.native="routerNavIndex = index"
          :to="'/'+ item.link"
          tag="li"
          replace
        >
          <span class="iconfont" :class="item.icon"></span>
          <br />
          {{item.name}}
          <div class="line"></div>
        </router-link>
      </ul>
    </div>

    <router-view></router-view>

    <!-- 建议框 -->
    <div class="suggest-wrap" v-show="isShowSuggest">
      <transition name="suggest-fade">
        <Suggest v-show="isShowSuggest"
        @closeSuggest="closeSuggest()"></Suggest>
      </transition>
    </div>

    <!-- 备案 -->
    <a class="beian" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备18154715号</a>
  </div>
</template>

<script>

//百度统计代码
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?7a6c91d8879d825cbab02fcc1d59e227";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();

import "./assets/font/iconfont.css";
import Nav from "./components/Nav";
import Suggest from "./components/Suggest";
export default {
  name: "app",
  data() {
    return {
      routerNavData: [
        //路由导航渲染数据
        { name: "最近", link: "zuijin", icon: "icon-bangdan" },
        { name: "推荐", link: "tuijian", icon: "icon-tuijian" },
        { name: "视频", link: "shipin", icon: "icon-shipin" },
        { name: "音乐", link: "yinyue", icon: "icon-tubiaozhizuomobanyihuifu-"},
        { name: "电影", link: "dianying", icon: "icon-dianying" },
        { name: "购物", link: "gouwu", icon: "icon-gouwu" },
        { name: "直播", link: "zhibo", icon: "icon-airudiantubiaohuizhi-zhuanqu_zhibojian" },
        { name: "男生", link: "nansheng", icon: "icon-nanxing" },
        { name: "女生", link: "nvsheng", icon: "icon-iconnvhai" },
        { name: "出行", link: "chuxing", icon: "icon-lvyou" },
        { name: "摄影", link: "sheying", icon: "icon-ziyuan" },
        { name: "设计", link: "sheji", icon: "icon-shejishi1" },
        { name: "剪辑", link: "jianji", icon: "icon-shipinjianji" },
        { name: "程序员", link: "chengxuyuan", icon: "icon-daimaguanli" },
        { name: "新媒体", link: "xinmeiti", icon: "icon-xinmeiti"},
        { name: "外贸", link: "waimao", icon: "icon-maoyijinchukoulingshoupifa"},
        { name: "每日", link: "meiri", icon: "icon-taiyang" },
        { name: "工具", link: "gongju", icon: "icon-icon-test" }
      ],
      isShowSuggest: false    //控制显示意见反馈
    };
  },
  components: {
    Nav,
    Suggest
  },
  methods: {
    closeSuggest() {
      this.isShowSuggest = !this.isShowSuggest
    }
  }
};
</script>

<style lang="less" scoped>
@baseColor: #5d98f4;
#app {
  height: 100%;
  background: url("./assets/images/body_bg.jpg");
}
.router-nav {
  position: relative;
  width: 1200px;
  margin: 30px auto 20px;
  border-bottom: 1px solid #ddd;
  li {
    float: left;
    width: 66.6px;
    margin-bottom: -2px;
    padding-bottom: 10px;
    text-align: center;
    color: #bfbfbf;
    cursor: pointer;
    &:hover {
      color: @baseColor;
    }
    &.active {
      color: @baseColor;
      .line {
        width: 66.6px;
      }
    }
    span {
      font-size: 32px;
      display: inline-block;
      margin-bottom: 8px;
    }
  }
  .line {
    position: relative;
    top: 10px;
    margin: 0 auto;
    width: 0px;
    height: 3px;
    background: @baseColor;
    transition: all 0.3s ease-in-out;
  }
}

.suggest-btn{
  position: absolute;
  bottom: 10px;
  left: 50%;
  margin-left: 520px;
  font-size: 14px;
  padding: 4px 10px;
  border-radius: 4px;
  color: #b7b7b7;
  border: 1px solid #d6d6d6;
  cursor: pointer;
}

// 建议框底部遮罩
.suggest-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .6);
}

//建议弹框动画
.suggest-fade-enter-active,
.suggest-fade-leave-active {
  transition: all .5s;
}
.suggest-fade-enter, .suggest-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-30px);
}

.beian {
  display: block;
  position: absolute;
  bottom: 10px;
  right: 20px;
  color: #999;
}
</style>
